import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { changeAddressFilterGroup, clearFiltersIfEmpty } from '../store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';
import { filterLabelMappings } from 'bundles/research/index/research_constants';
import { isPresent } from 'helpers/string_helpers';

import AddressFilterGroup from 'components/research_property/address_filter_group';
import FilterButton from 'components/search_sidebar/filter_button';

export class ResearchAddressFilterGroup extends React.Component {
  static propTypes = {
    addressFilter: PropTypes.object.isRequired,
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    marketTypeOptions: PropTypes.array.isRequired,
    microMarketTypeOptions: PropTypes.array.isRequired,
    subMarketTypeOptions: PropTypes.array.isRequired,
    onAddressFilterChange: PropTypes.func.isRequired
  };

  handleRetrieveRecords = () => {
    const { clearFiltersIfEmpty, delayRetrieveRecords } = this.props;
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  };

  handleAddressFilterChange = (e, name) => {
    const { addressFilter, onAddressFilterChange } = this.props;

    if (name == "cities") {
      let cities = [];

      if (addressFilter[name].includes(e)) {
        addressFilter[name] = addressFilter[name].filter(city => city !== e);
      } else {
        cities = [...addressFilter[name], e];
        addressFilter[name] = cities;
        addressFilter["currentCity"] = "";
      }
    } else {
      const value = e ? e.target.value : "";
      addressFilter[name] = value;
    }

    onAddressFilterChange(addressFilter);
    this.handleRetrieveRecords();
  };


  render() {
    const { addressFilter } = this.props;
    const filtersApplied = Object.keys(addressFilter).some((key) => {
      if (key === "cities") return addressFilter[key].length > 0;
      return isPresent(addressFilter[key]);
    });

    return (
      <FilterButton
        filtersApplied={filtersApplied}
        label="Location"
        name="location"
      >
        <AddressFilterGroup
          {...this.props}
          filterLabelMappings={filterLabelMappings}
          onAddressFilterChange={this.handleAddressFilterChange}
        />
      </FilterButton>
    );
  }
}


const mapStateToProps = state => ({
  addressFilter: state.query.addressFilter,
  marketTypeOptions: state.static.marketTypeOptions,
  microMarketTypeOptions: state.static.microMarketTypeOptions,
  subMarketTypeOptions: state.static.subMarketTypeOptions
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,

  onAddressFilterChange: changeAddressFilterGroup,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResearchAddressFilterGroup);
